'use es6';

import { createContext } from 'react';
const noopComponent = () => null;
export const AsyncComponentsContext = /*#__PURE__*/createContext({
  AsyncUIAvatar: noopComponent
});